require("./aresLoanRepaymentPlanView.scss");
const PropTypes = require("prop-types");
// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const { withRouter } = require("react-router-dom");
// @ actions
const {
    fetchRepaymentPlan,
    repaymentPlanReset,
} = require("../../actions/loanRepaymentPlan");
const collectiveActions = require("actions/collectives");
const partialAmortizationAction = require("../../actions/loanPartialAmortization");
const mortgageRequestTaxesInformationActions = require("actions/mortgageRequest/mortgageRequestTaxesInformation");
// @ components
const LoanHeader = require("../../components/loansAndMortgages/loans/loanHeader/loanHeader");
const ARESLoanRepaymentPlan = require("../../components/loansAndMortgages/aresLoanRepaymentPlan/aresLoanRepaymentPlan");
// @ helpers
const { formatText } = require("core/i18n").i18n;
// @constants
const {
    MULTICHANNEL_UI_COMPONENT,
    MORTGAGE_TAXES_GROUP_CODE,
} = require("constants/index");
const { YEAR_MONTHS } = require("../../loansConstants/index");
const {
    MORTGAGE_PRODUCT_NUMBER,
    getMortgageTypeProductSubType,
} = require("constants/mortgageRequestType");
const MortgagesCollectiveTagTooltip = require("components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip");

class ARESLoanRepaymentPlanView extends React.Component {
    componentDidMount() {
        const {
            immLoans,
            match: {params: { loanId }},
            fetchRepaymentPlan,
            getCollectiveInfo,
            requestPlanAmortization,
            requestPartialAmortization,
            immAccounts,
        } = this.props;
        const immLoan = immLoans.getIn(["byId", loanId], false);

        if (
            immLoan &&
            !immLoan.getIn("isOldLoan") &&
            !immLoan.get("isRestrictedLoan")
        ) {
            const productType = {
                type: immLoan.get("product"),
                subType: immLoan.get("productSubType"),
                standard: immLoan.get("productStandard"),
            };

            fetchRepaymentPlan(loanId);
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
            requestPlanAmortization(immLoan);
            requestPartialAmortization(immLoan, immAccounts);
        } else {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    componentDidUpdate(prevProps) {
        const { immPartialAmortization } = this.props;

        if (!immPartialAmortization.get("isFetchingPartialAmortization")) {
            const {
                immLoans,
                match: {params: { loanId }},
                immTaxesInformation,
            } = prevProps;
            const taxesHasBeenFetched = immTaxesInformation.get(
                "taxesHasBeenFetched"
            );
            const taxesIsFetching = immTaxesInformation.get("isFetching");

            const immLoan = immLoans.getIn(["byId", loanId], false);
            const productType = getMortgageTypeProductSubType(
                immLoan.get("productSubType")
            );
            const productNumber = MORTGAGE_PRODUCT_NUMBER[productType];

            if (!taxesHasBeenFetched && !taxesIsFetching && !!productNumber) {
                const term =
                    immPartialAmortization.getIn(
                        [
                            "loanPartialAmortization",
                            "datosGrles",
                            "plazoLiquidacion",
                        ],
                        0
                    ) / YEAR_MONTHS;
                const collectiveType = prevProps.immProfile.get(
                    "collectiveType"
                );
                const code3 = collectiveType.get("code3");
                const code4 = collectiveType.get("code4");
                const mortgageInfo = {
                    type: productNumber,
                    duration: term,
                    code3,
                    code4,
                    groupCode: MORTGAGE_TAXES_GROUP_CODE,
                };
                prevProps.taxesInformationRequest(mortgageInfo);
            }
        }
    }

    componentWillUnmount() {
        this.props.clear();
    }

    buildTagTooltip() {
        const {
            match: {params: { loanId }},
            immLoans,
            immTaxesInformation,
            immPartialAmortization,
        } = this.props;
        const immLoan = immLoans.getIn(["byId", loanId], false);
        let taxes, productType, monthlyFee, tooltipContentMortgage;
        if (immLoan) {
            if (immTaxesInformation.get("taxesHasBeenFetched")) {
                taxes = immTaxesInformation.get("taxes").toJS();
                productType = getMortgageTypeProductSubType(
                    immLoan.get("productSubType")
                );
                monthlyFee = immPartialAmortization.get("receiptTotal");
            }
            tooltipContentMortgage = (
                <MortgagesCollectiveTagTooltip
                    taxes={taxes}
                    mortgageType={productType}
                    monthlyFee={monthlyFee}
                />
            );
        }
        return tooltipContentMortgage;
    }

    buildBreadcrumb(immLoan) {
        const loanPrefix = immLoan.get('isPersonal') ? '' : `-${immLoan.get('type')}`;
        return [
            {
                text: formatText("breadcrumb-loans"),
                url: `/myprofile/loans-mortgages`,
            },
            {
                text: immLoan.get("alias"),
                url: `/myprofile/loans-mortgages/ares${loanPrefix}-loans/${immLoan.get(
                    "loanId"
                )}`,
            },
            {
                text: formatText("breadcrumb-loanRepaymentPlan"),
            },
        ];
    }
    render() {
        const {
            immLoans,
            match: {params: { loanId }},
            immLoanRepaymentPlan,
        } = this.props;
        const immLoan = immLoans.getIn(["byId", loanId], false);

        let breadcrumb;
        if (
            immLoan &&
            !immLoan.getIn("isOldLoan") &&
            !immLoan.get("isRestrictedLoan")
        ) {
            const headerTitle = immLoan.get("alias");

            breadcrumb = this.buildBreadcrumb(immLoan);
            return (
                <article className="ares-loan-repayment-plan-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadcrumb}
                        title={headerTitle}
                        showDetails={false}
                        isARES
                />
                    <section className="loan-repayment-plan-view__body">
                        <div className="row no-outside-gutter">
                            <div className="col-xs-9">
                                <ARESLoanRepaymentPlan
                                    immLoan={immLoan}
                                    immLoanRepaymentPlan={immLoanRepaymentPlan}
                                    loanId={loanId}
                                    tooltipContentMortgage={this.buildTagTooltip()}
                            />
                            </div>
                            <div className="col-xs-3"></div>
                        </div>
                    </section>
                </article>
            );
        }

        return null;
    }
}

ARESLoanRepaymentPlanView.propTypes = {
    immLoans: PropTypes.object.isRequired,
    immLoanRepaymentPlan: PropTypes.object,
    fetchRepaymentPlan: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    getCollectiveInfo: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    productAds: PropTypes.object,
    immTaxesInformation: PropTypes.object,
    match: PropTypes.object.isRequired,
    immPartialAmortization: PropTypes.object.isRequired,
    taxesInformationRequest: PropTypes.func,
    requestPlanAmortization: PropTypes.func,
    requestPartialAmortization: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

};

module.exports = withRouter(connect(
    (state) => ({
        immLoans: state.loans,
        immLoanRepaymentPlan: state.loanRepaymentPlan,
        immProfile: state.profile,
        immTaxesInformation: state.mortgageRequestTaxesInformation,
        immPartialAmortization: state.loanPartialAmortization,
        immAccounts: state.accounts,
    }),
    {
        fetchRepaymentPlan,
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        requestPlanAmortization:
            partialAmortizationAction.requestPlanAmortization,
        taxesInformationRequest:
            mortgageRequestTaxesInformationActions.taxesInformationRequest,
        clear: repaymentPlanReset,
        requestPartialAmortization:
            partialAmortizationAction.requestPartialAmortization,
    }
)(ARESLoanRepaymentPlanView));
